'use client';
import { useEffect, useRef } from 'react';

const TOTAL_TRIES = 10;
// Used for view tracking
// https://www.algolia.com/doc/guides/sending-events/connectors/google-tag-manager/#send-hits-viewed-event
// https://www.algolia.com/doc/api-reference/widgets/insights/react/
export const SearchInsightsMiddleware = () => {
    const counter = useRef(0);
    const aaIsLoaded = useRef(false);

    // send algolia user token to gtm after aa is loaded
    useEffect(() => {
        const interval = setInterval(() => {
            if (counter.current >= TOTAL_TRIES) {
                clearInterval(interval);
                return;
            }
            if (!window.aa) {
                counter.current = counter.current ? counter.current + 1 : 1;
                return;
            }
            aaIsLoaded.current = true;
            window.aa('getUserToken', {}, (err: Error | null, userToken: string) => {
                if (err) {
                    console.error(err);
                    return;
                }
                console.log(userToken);

                window.dataLayer.push(
                    {
                        algoliaUserToken: userToken,
                    },
                    { immediate: true }
                );
            });
            clearInterval(interval);
        }, 500);
        return () => clearInterval(interval);
    }, []);

    return null;
};

export default SearchInsightsMiddleware;
